var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product.hasInfoBoxOpen)?_c('div',{staticClass:"model-info-box has-text-grey is-size-6"},[_c('div',{staticClass:"delete is-clickable",on:{"click":function($event){_vm.product.hasInfoBoxOpen = false}}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.product.description)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }